import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  CrossPlatformLocationIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby"; // Import Gatsby's Link component
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "As a leading name for mobile app development in Chicago, we feel obliged to cater to those businesses and build feature-rich apps for both android and iOS platforms. We offer the best Android app development services in Chicago for the clients eagerly looking for experts in the domain.",
  },
  {
    icon: IphoneIcon,
    title: "Iphone App Development",
    description: (
      <>
        Our{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iOS app development services
        </Link>{" "}
        in Chicago help businesses get superfast native iOS apps built using
        efficient iOS app development languages and frameworks like Swift,
        Objective C, XCode, etc. From simple consumer-business iOS apps to fully
        functional on-demand applications and more, our iOS app development
        services in Chicago help you kickstart your app entrepreneurial journey.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description: (
      <>
        As a leading{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development company,
        </Link>{" "}
        we have a track record of delivering exceptional service to our clients.
        You can rely on us to create resilient gaming applications for both
        Android and iOS platforms. We employ powerful tools and engines such as
        Unity, Unreal Engine, and Lumberyards to guarantee flawless game
        development.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description: (
      <>
        Elevate your business using Flutter, the most current and dependable
        technology in app development. We excel in this technology stack,
        offering diverse solutions to our clients. The exceptional
        high-definition user interface provided by our{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development services
        </Link>{" "}
        exceeds all expectations.
      </>
    ),
  },
  {
    icon: CrossPlatformLocationIcon,
    title: "Cross-Platform App Development",
    description:
      "Our cross-platform app development service helps your app reach a wider audience by maintaining its presence on both iOS and Android platforms. We deliver a high-performance and user-centric experience based on advanced frameworks like React Native and Flutter. You can leverage our expert resources to create maximum impact with our efficient cross-platform solutions as per your business needs.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "TekRevol as a premium React Native app development company harnesses the capabilities of this impeccable framework to create resilient mobile apps compatible with both Android and iOS platforms, guaranteeing extensive features and flawless execution based on our proficient team’s expertise.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>High-Impact Mobile App Development Services in Chicago</h2>
            <p className="impro_para">
              Explore top-tier mobile app development services in Chicago. Let’s
              build a progressive, secure, and feature-rich application tailored
              to your business functions. Our experienced app developers in
              Chicago leverage advanced technologies like AI, IoT, and
              blockchain for immersive user experiences. Upscale your digital
              presence with our expertise in native, hybrid, and cross-platform
              app development.
            </p>
            <p>
              Here are TekRevol’s mobile app development services in Chicago:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
